import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';

/**
 * Wrap admin routes that require an authenticated admin.
 * Shows nothing while the initial /me check is in flight to avoid flicker.
 */
export default function AdminProtectedRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="admin-auth-loading" className="min-h-screen flex items-center justify-center bg-[#FAF8F2]">
        <div className="w-8 h-8 rounded-full border-4 border-[#F26B1A]/30 border-t-[#F26B1A] animate-spin" />
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
